import StyledTextField from '@shared/components/core/field/StyledTextField';
import { IControlFieldProps } from '@shared/models/components/IControlFieldProps';
import { useTranslation } from 'react-i18next';

/** NOTE: not included in ControlTypeField */

function SuggestedPromptField({ value, onChange, disabled, placeholder, autoFocus }: IControlFieldProps) {
    const { t } = useTranslation();
    return (
        <StyledTextField
            disabled={disabled}
            fullWidth
            value={value}
            label={t('common:suggestedPrompts.title')}
            placeholder={placeholder}
            autoFocus={autoFocus}
            onChange={(e) => onChange(e.target.value)}
        />
    );
}

export default SuggestedPromptField;
